import React, { FC } from 'react';

export const DownloadIcon: FC<any> = ({ size = 15, stroke = '#7f7f7f', ...props }) => (
  <svg {...props} height={size} viewBox="0 0 15.5 15.5" width={size} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M148,446.5v.875A2.625,2.625,0,0,0,150.625,450h8.75A2.625,2.625,0,0,0,162,447.375V446.5m-3.5-3.5-3.5,3.5m0,0-3.5-3.5m3.5,3.5V436"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      transform="translate(-147.25 -435.25)"
    />
  </svg>
);
